<mojo-collection [overflowHidden]="false">
  <div
    class="assigned-jobs-header"
    mojo-collection-header
  >
    <span>
      Application History
      <span
        class="assigned-jobs-count">{{ totalNumberOfAssigns$ | async}}</span>
    </span>
    <mojo-sort-candidates
      [currentSortBy]="(sortFromStorage$ | async)"
      [menuItems]="sortMenuItems"
      (sortChanged)="sortBy($event)"
    >
    </mojo-sort-candidates>
  </div>

  <mojo-loader *ngIf="(assigns$ | async) === undefined"></mojo-loader>

  <div *ngIf="(assigns$ | async) as items">
    <mojo-collection-list
      [items]="items"
      [itemTemplate]="assignItem"
      *ngIf="items?.length> 0; else empty"
      data-cy="candidate-assigns-collection-list"
    >
    </mojo-collection-list>
  </div>
</mojo-collection>

<mojo-pagination
  [pagination]="pagination$ | async"
  (pageChange)="changeFilter([{filterName: 'offset', filterValue: $event}])"
>
</mojo-pagination>

<router-outlet></router-outlet>

<ng-template #empty>
  <span class="no-results">{{ emptyMessage }}</span>
</ng-template>

<ng-template
  #assignItem
  let-item
>
  <mojo-assigns-job-container [association]="item">
  </mojo-assigns-job-container>
</ng-template>
